// extracted by mini-css-extract-plugin
export default {"icon-button-wrapper":"_2kT9j","iconButtonWrapper":"_2kT9j","number":"_3w_8_","red":"_1WsTW","green":"_1DqWT"};